import styled from 'styled-components';

const StyledGradientSpacer = styled.div<{ $rotation: number }>`
  height: 145px;
  margin-top: 1rem;
  background: radial-gradient(99.87% 99.87% at 49.11% 30.47%, rgba(15, 156, 139, 0.18) 0%, rgba(217, 217, 217, 0) 100%);
  filter: blur(10px);
  transform: rotate(${({ $rotation }) => $rotation}deg);
`;

export { StyledGradientSpacer };
